export enum NotificationStatus {
	DRAFT = "DRAFT",
	SENT = "SENT",
	ERROR = "ERROR", // ← READ removed, matches backend
}

export enum NotificationType {
	EMAIL = "EMAIL",
	APP = "APP",
	DIGEST = "DIGEST",
}

export enum NotificationContentType {
	// Task events
	TASK_ASSIGNED = "TASK_ASSIGNED",
	TASK_UNASSIGNED = "TASK_UNASSIGNED",
	TASK_STATUS_CHANGED = "TASK_STATUS_CHANGED",
	TASK_PRIORITY_CHANGED = "TASK_PRIORITY_CHANGED",
	TASK_COMMENTED = "TASK_COMMENTED",
	TASK_DELETED = "TASK_DELETED",

	// Subtask events
	SUBTASK_ASSIGNED = "SUBTASK_ASSIGNED",
	SUBTASK_UNASSIGNED = "SUBTASK_UNASSIGNED",
	SUBTASK_STATUS_CHANGED = "SUBTASK_STATUS_CHANGED",
	SUBTASK_COMPLETED = "SUBTASK_COMPLETED",
	SUBTASK_COMMENTED = "SUBTASK_COMMENTED",
	SUBTASK_DELETED = "SUBTASK_DELETED",

	// Mention events
	MENTIONED_IN_TASK = "MENTIONED_IN_TASK",
	MENTIONED_IN_SUBTASK = "MENTIONED_IN_SUBTASK",

	// Tag events
	TAG_ADDED_TO_TASK = "TAG_ADDED_TO_TASK",
	TAG_REMOVED_FROM_TASK = "TAG_REMOVED_FROM_TASK",
}

export enum NotificationCategory {
	ASSIGNMENT = "ASSIGNMENT",
	STATUS = "STATUS",
	COMMENT = "COMMENT",
	TAG = "TAG",
	SYSTEM = "SYSTEM",
}

export enum NotificationEntityType {
	TASK = "TASK",
	SUBTASK = "SUBTASK",
	TAG = "TAG",
	USER = "USER",
}

export enum NotificationFrequency {
	INSTANT = "INSTANT",
	DAILY = "DAILY",
	WEEKLY = "WEEKLY",
	OFF = "OFF",
}

// ── UI-only ────────────────────────────────────────────────────────────

export enum NotificationPriority {
	LOW = "LOW",
	MEDIUM = "MEDIUM",
	HIGH = "HIGH",
	URGENT = "URGENT",
}

export enum NotificationPreferenceGroup {
	TASK_ACTIVITY = "TASK_ACTIVITY",
	SUBTASK_ACTIVITY = "SUBTASK_ACTIVITY",
	MENTIONS = "MENTIONS",
	TAGS = "TAGS",
}

export const CONTENT_TYPE_DISPLAY_NAMES: Record<NotificationContentType, string> = {
	[NotificationContentType.TASK_ASSIGNED]: "Task Assigned",
	[NotificationContentType.TASK_UNASSIGNED]: "Task Unassigned",
	[NotificationContentType.TASK_STATUS_CHANGED]: "Task Status Changed",
	[NotificationContentType.TASK_PRIORITY_CHANGED]: "Task Priority Changed",
	[NotificationContentType.TASK_COMMENTED]: "Task Comment",
	[NotificationContentType.TASK_DELETED]: "Task Deleted",
	[NotificationContentType.SUBTASK_ASSIGNED]: "Subtask Assigned",
	[NotificationContentType.SUBTASK_UNASSIGNED]: "Subtask Unassigned",
	[NotificationContentType.SUBTASK_STATUS_CHANGED]: "Subtask Status Changed",
	[NotificationContentType.SUBTASK_COMPLETED]: "Subtask Completed",
	[NotificationContentType.SUBTASK_COMMENTED]: "Subtask Comment",
	[NotificationContentType.SUBTASK_DELETED]: "Subtask Deleted",
	[NotificationContentType.MENTIONED_IN_TASK]: "Mentioned in Task",
	[NotificationContentType.MENTIONED_IN_SUBTASK]: "Mentioned in Subtask",
	[NotificationContentType.TAG_ADDED_TO_TASK]: "Tag Added to Task",
	[NotificationContentType.TAG_REMOVED_FROM_TASK]: "Tag Removed from Task",
};

export const CONTENT_TYPE_DEFAULT_CATEGORY: Record<NotificationContentType, NotificationCategory> =
	{
		[NotificationContentType.TASK_ASSIGNED]: NotificationCategory.ASSIGNMENT,
		[NotificationContentType.TASK_UNASSIGNED]: NotificationCategory.ASSIGNMENT,
		[NotificationContentType.TASK_STATUS_CHANGED]: NotificationCategory.STATUS,
		[NotificationContentType.TASK_PRIORITY_CHANGED]: NotificationCategory.STATUS,
		[NotificationContentType.TASK_COMMENTED]: NotificationCategory.COMMENT,
		[NotificationContentType.TASK_DELETED]: NotificationCategory.SYSTEM,
		[NotificationContentType.SUBTASK_ASSIGNED]: NotificationCategory.ASSIGNMENT,
		[NotificationContentType.SUBTASK_UNASSIGNED]: NotificationCategory.ASSIGNMENT,
		[NotificationContentType.SUBTASK_STATUS_CHANGED]: NotificationCategory.STATUS,
		[NotificationContentType.SUBTASK_COMPLETED]: NotificationCategory.STATUS,
		[NotificationContentType.SUBTASK_COMMENTED]: NotificationCategory.COMMENT,
		[NotificationContentType.SUBTASK_DELETED]: NotificationCategory.SYSTEM,
		[NotificationContentType.MENTIONED_IN_TASK]: NotificationCategory.COMMENT,
		[NotificationContentType.MENTIONED_IN_SUBTASK]: NotificationCategory.COMMENT,
		[NotificationContentType.TAG_ADDED_TO_TASK]: NotificationCategory.TAG,
		[NotificationContentType.TAG_REMOVED_FROM_TASK]: NotificationCategory.TAG,
	};
